<template>
  <!--
    An organization's security / acceptable-use notice (GitLab #1072), shown
    on the login page and once on entering the app. Passive display only:
    nothing is recorded when it is shown or dismissed.

    - role="region" + aria-label makes it a named landmark screen-reader users
      can find, rather than an alert that interrupts on every page load.
    - The text is admin-entered plain text rendered by interpolation (never
      v-html); white-space: pre-line keeps the admin's paragraph breaks.
    - text-dark on bg-grey-2 is roughly 14:1, well above the 4.5:1 AA minimum.
  -->
  <q-banner
    v-if="text"
    rounded
    class="security-banner bg-grey-2 text-dark"
    role="region"
    aria-label="Security notice"
    data-test="security-banner"
  >
    <template v-slot:avatar>
      <q-icon name="security" color="dark" size="sm" aria-hidden="true" />
    </template>
    <p class="security-banner__text q-mb-none">{{ text }}</p>
    <template v-if="dismissible" v-slot:action>
      <q-btn
        flat
        color="dark"
        label="Dismiss"
        aria-label="Dismiss security notice"
        data-test="security-banner-dismiss"
        @click="$emit('dismiss')"
      />
    </template>
  </q-banner>
</template>

<script>
export default {
  name: 'SecurityBanner',
  props: {
    text: {
      type: String,
      default: null
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['dismiss']
}
</script>

<style scoped>
.security-banner__text {
  white-space: pre-line;
  overflow-wrap: anywhere;
}
</style>
